import React, {useMemo} from 'react';
import _ from 'lodash';
import ChartLoader from '@/pages/dashboard/_charts/ChartLoader';
import LegendChart from '@/pages/dashboard/_charts/LegendChart';
import {useProjectsContext} from "@/pages/dashboard/ProjectsContext";

export default function ProjectActivityYear(props) {
  const {activities, subtitle} = props;
  const {filteredProjects, isLoading} = useProjectsContext();

  if (isLoading) {
    return (
      <ChartLoader
        title="Projects by Activity"
        subtitle={subtitle || 'For school year'}
      />
    );
  }
  const allActivities = useMemo(() => activities?.data?.map(s => s?.data?.name), [activities]);

  // get an object like this for the counts
  // {"Workshop":13,"Speaker":4,"Guest Instructor":10,"Advisor":2,"Challenge":1,"Demonstration":6,"Performance":1,"Tour":1,"Mentor":2}
  const counts = _.countBy(filteredProjects, p => p.activityName)

  // add in missing activities with a count of 0
  for (const activity of allActivities) {
    if (!counts[activity]) counts[activity] = 0;
  }

  // sort by the value to get an array of objects like this:
  // [
  //   { label: "Workshop", value: 13 },
  //   { label: "Guest Instructor", value: 10 },
  //   { label: "Demonstration", value: 6 },
  //   ...
  // ]
  const sorted = _.orderBy(
    Object.entries(counts).map(([label, value]) => ({label, value})),
    "value",
    "desc"
  );
  // Turn the sorted array in to arrays of labels and values
  const labels = sorted.map(d => d.label)
  const series = sorted.map(d => d.value)


  return (
    <LegendChart
      title="Projects by Activity"
      subtitle={subtitle || 'For school year'}
      labels={labels}
      series={series}
    />
  );
}
